import React, { Component } from "react";

const Camera = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1855 9.71144C10.2361 10.8565 9.31196 11.8248 8.1216 11.8734C8.03393 11.8771 3.75954 11.8685 3.75954 11.8685C2.57495 11.9584 1.53819 11.1072 1.44475 9.96644C1.43771 9.88144 1.43963 5.29512 1.43963 5.29512C1.38715 4.14885 2.31 3.17812 3.50099 3.12761C3.58995 3.1233 7.85857 3.13131 7.85857 3.13131C9.04893 3.04261 10.0889 3.9 10.181 5.04628C10.1874 5.12881 10.1855 9.71144 10.1855 9.71144Z"
        stroke="#B7BABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1875 6.2374L12.2456 4.55302C12.7556 4.13552 13.5206 4.49927 13.52 5.1574L13.5125 9.75052C13.5119 10.4086 12.7462 10.7693 12.2375 10.3518L10.1875 8.6674"
        stroke="#B7BABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Camera.defaultProps = {
  width: "15",
  height: "15",
};

export default Camera;
